import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://sampaolicreazioni.it';

/**
 * Dynamically sets hreflang alternate link tags and html lang attribute
 * based on the current route and i18n language.
 */
export function HreflangTags() {
  const { pathname } = useLocation();

  useEffect(() => {
    const url = `${BASE_URL}${pathname}`;

    const setLink = (hreflang: string, href: string) => {
      const selector = `link[rel="alternate"][hreflang="${hreflang}"]`;
      let el = document.querySelector(selector) as HTMLLinkElement | null;
      if (!el) {
        el = document.createElement('link');
        el.rel = 'alternate';
        el.setAttribute('hreflang', hreflang);
        document.head.appendChild(el);
      }
      el.href = href;
    };

    setLink('it', url);
    setLink('en', url);
    setLink('x-default', url);
  }, [pathname]);

  return null;
}
